// [VexFlow](https://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
// Author Taehoon Moon 2014
// MIT License
import { Clef } from './clef';
import { Glyph } from './glyph';
import { Note } from './note';
import { Category } from './typeguard';
/** ClefNote implements clef annotations in measures. */
export class ClefNote extends Note {
    constructor(type, size, annotation) {
        super({ duration: 'b' });
        this.type = type;
        this.clef = new Clef(type, size, annotation);
        this.glyph = new Glyph(this.clef.clef.code, this.clef.clef.point);
        this.setWidth(this.glyph.getMetrics().width);
        // Note properties
        this.ignore_ticks = true;
    }
    static get CATEGORY() {
        return Category.ClefNote;
    }
    /** Set clef type, size and annotation. */
    setType(type, size, annotation) {
        this.type = type;
        this.clef = new Clef(type, size, annotation);
        this.glyph = new Glyph(this.clef.clef.code, this.clef.clef.point);
        this.setWidth(this.glyph.getMetrics().width);
        return this;
    }
    /** Get associated clef. */
    getClef() {
        return this.clef.clef;
    }
    /** Set associated context. */
    setContext(context) {
        super.setContext(context);
        this.glyph.setContext(this.getContext());
        return this;
    }
    preFormat() {
        this.preFormatted = true;
        return this;
    }
    /** Render clef note. */
    draw() {
        var _a;
        const stave = this.checkStave();
        if (!this.glyph.getContext()) {
            this.glyph.setContext(this.getContext());
        }
        this.setRendered();
        const abs_x = this.getAbsoluteX();
        this.glyph.setStave(stave);
        this.glyph.setYShift(stave.getYForLine((_a = this.clef.clef.line) !== null && _a !== void 0 ? _a : 0) - stave.getYForGlyphs());
        this.glyph.renderToStave(abs_x);
        // If the Vex.Flow.Clef has an annotation, such as 8va, draw it.
        if (this.clef.annotation !== undefined) {
            const attachment = new Glyph(this.clef.annotation.code, this.clef.annotation.point);
            if (!attachment.getContext()) {
                attachment.setContext(this.getContext());
            }
            attachment.setStave(stave);
            attachment.setYShift(stave.getYForLine(this.clef.annotation.line) - stave.getYForGlyphs());
            attachment.setXShift(this.clef.annotation.x_shift);
            attachment.renderToStave(abs_x);
        }
    }
}
